import { AnyAction } from "redux";
import { ProjectData } from "../../components/ProjectSelectorWrapper/type";
import { ActionTypes } from "./action";
import { SpecialInstancesResponse } from "../../packages/Api/data/instances/types";

export interface IProjectModuleState {
    projectState: IProjectState;
}

export interface IProjectState {
    activeProject?: ProjectData;
    projects?: ProjectData[];
    specialInstances?: SpecialInstancesResponse;
}

export const initialState: Readonly<IProjectState> = {
};

export function reducer(state: IProjectState = initialState, action: AnyAction): IProjectState {
    switch (action.type) {
        case ActionTypes.SetActiveProject: {
            return {
                ...state,
                activeProject: action.payload.activeProject,
                specialInstances: undefined
            };
        }

        case ActionTypes.SetProjects: {
            return {
                ...state,
                projects: action.payload.projects,
            };
        }

        case ActionTypes.LoadSpecialInstancesDone: {
            return {
                ...state,
                specialInstances: action.payload.response,
            };
        }

        default:
            return state;
    }
}
